import { useStatsig } from '@atlassian/mpac-feature-flags';
import { useLocation } from '@atlassian/mpac-ui';
import { useEffect, useState } from 'react';
import { defaultFilterDefinitions, transformedDefaultFilterDefinitions } from '../../utils/filters/searchPageFiltersConfig';
import { getFilterOptionsFromUrl } from '../../utils/UrlMapUtils';
export const useCommitOptions = (filterOptions, setSelectedOptions, setShowAllFilters) => {
  const {
    search
  } = useLocation();
  const [commitOptions, setCommitOptions] = useState({});
  const {
    enableFlexibleBillingFilter
  } = useStatsig();
  const filterDefinitions = enableFlexibleBillingFilter() ? transformedDefaultFilterDefinitions() : defaultFilterDefinitions;
  useEffect(() => {
    const selectedOptionsFromURL = getFilterOptionsFromUrl({
      filterOptions,
      search
    });
    if (Object.keys(selectedOptionsFromURL).length > 0) {
      // check if the filter id is hidden by default in defaultFilterDefinitions
      const hiddenFilterIds = filterDefinitions.map(filterConfig => filterConfig.hiddenByDefault ? filterConfig.filterId : null);
      const selectedFilterIds = Object.keys(selectedOptionsFromURL);
      // if any of filterId in selectedFilterIds is present in hiddenFilterIds, then show all filters
      const toShowAllFilters = selectedFilterIds.some(filterId => hiddenFilterIds.includes(filterId));
      // if previous state is already true, then don't change it
      setShowAllFilters(prevState => prevState || toShowAllFilters);
    }
    setSelectedOptions(selectedOptionsFromURL);
    setCommitOptions(selectedOptionsFromURL);
  }, [filterOptions, search, setSelectedOptions, setShowAllFilters]);
  return {
    commitOptions,
    setCommitOptions
  };
};